import { render } from "./AuditLogs.vue?vue&type=template&id=580daf51"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__